// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__mAoQm","list":"styles_list__2ODAf"};